// import React, { useState } from 'react';
// import { motion, AnimatePresence } from 'framer-motion';
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import '../design/LoginModal.css';

// // --- INLINE SVG ICONS ---
// const UserIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>;
// const LockIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>;
// const GoogleIcon = () => <svg viewBox="0 0 48 48" width="24px" height="24px"><path fill="#FFC107" d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"></path><path fill="#FF3D00" d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"></path><path fill="#4CAF50" d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.222,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"></path><path fill="#1976D2" d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.574l6.19,5.238C39.99,34.556,44,29.865,44,24C44,22.659,43.862,21.35,43.611,20.083z"></path></svg>;

// export default function LoginModal({ isOpen, onClose, openRegister }) {
//   const [username, setUsername] = useState('');
//   const [password, setPassword] = useState('');
//   const [showPassword, setShowPassword] = useState(false);

//   // Validation
//   const validateLogin = (credentials) => {
//     const errors = {};
//     if (!credentials.username) errors.username = "Username is required.";
//     if (!credentials.password) errors.password = "Password is required.";
//     return errors;
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     const errors = validateLogin({ username, password });
//     if (Object.keys(errors).length > 0) {
//       Object.values(errors).forEach(err => toast.error(err));
//       return;
//     }
//     toast.info("Logging in...");
//     setTimeout(() => {
//       if (username === "investor" && password === "password") {
//         toast.success("✅ Login successful! Welcome, Investor.");
//         localStorage.setItem('investor_session', JSON.stringify({ name: 'Investor User', user_type: 'investor'}));
//       } else if (username === "brand" && password === "password") {
//         toast.success("✅ Login successful! Welcome, Brand.");
//         localStorage.setItem('userSession', JSON.stringify({ name: 'Brand User', user_type: 'brand'}));
//       } else {
//         toast.error("❌ Invalid credentials.");
//       }
//     }, 1500);
//   };

//   // Framer Motion Variants
//   const backdropVariants = { hidden: { opacity: 0 }, visible: { opacity: 1 } };
//   const modalVariants = { hidden: { opacity: 0, scale: 0.9, y: -50 }, visible: { opacity: 1, scale: 1, y: 0, transition: { type: 'spring', stiffness: 260, damping: 25, staggerChildren: 0.05 } }, exit: { opacity: 0, scale: 0.9, y: 50, transition: { duration: 0.2 } } };
//   const itemVariants = { hidden: { opacity: 0, y: 20 }, visible: { opacity: 1, y: 0 } };

//   return (
//     <>
//       <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
//       <AnimatePresence>
//         {isOpen && (
//           <div className="login-modal-overlay">
//             <motion.div
//               className="login-modal-backdrop"
//               variants={backdropVariants}
//               initial="hidden"
//               animate="visible"
//               exit="hidden"
//               onClick={onClose}
//             />
//             <motion.div
//               className="login-modal-box"
//               variants={modalVariants}
//               initial="hidden"
//               animate="visible"
//               exit="exit"
//             >
//               {/* --- Login Form --- */}
//               <motion.div className="login-form-content" variants={itemVariants}>
//                 <button className="close-modal-btn" onClick={onClose}>✖</button>
//                 <h2 className="login-title">Login to Your Account</h2>
//                 <form onSubmit={handleSubmit}>
//                   <motion.div className="input-group" variants={itemVariants}>
//                     <span className="icon"><UserIcon /></span>
//                     <input
//                       type="text"
//                       placeholder="Username"
//                       value={username}
//                       onChange={(e) => setUsername(e.target.value)}
//                     />
//                   </motion.div>
//                   <motion.div className="input-group password-group" variants={itemVariants}>
//                     <span className="icon"><LockIcon /></span>
//                     <input
//                       type={showPassword ? 'text' : 'password'}
//                       placeholder="Password"
//                       value={password}
//                       onChange={(e) => setPassword(e.target.value)}
//                     />
//                     <span
//                       className="toggle-password"
//                       onClick={() => setShowPassword(!showPassword)}
//                       title={showPassword ? 'Hide Password' : 'Show Password'}
//                     >
//                       {showPassword ? '🙈' : '👁️'}
//                     </span>
//                   </motion.div>
//                   <motion.div className="submit-row" variants={itemVariants}>
//                     <button type="submit" className="submit-btn">SIGN IN</button>
//                     <a href="#" className="forgot-link">Forgot Password?</a>
//                   </motion.div>
//                 </form>

//                 <motion.div className="social-login" variants={itemVariants}>
//                   <p className="or-text">or Sign in With</p>
//                   <button className="google-btn"><GoogleIcon /></button>
//                   <p className="register-text">
//                     New User?{' '}
//                     <a href="#" onClick={(e) => { e.preventDefault(); onClose(); openRegister(); }}>
//                       Click here to Register
//                     </a>
//                   </p>
//                 </motion.div>
//               </motion.div>

//               {/* --- Why Register Section --- */}
//               <motion.div className="why-register" variants={itemVariants}>
//                <div>
//   <h4>Welcome Back!</h4>
//   <p>Access your personalized dashboard and manage your <strong>franchise opportunities</strong> seamlessly.</p>
//   <p>Stay connected with a network of <strong>investors, experts, and entrepreneurs</strong> to grow your business.</p>
//   <p>Track your applications, get expert guidance, and <strong>expand your business</strong> efficiently with FranmaxIndia.</p>
// </div>

//               </motion.div>
//             </motion.div>
//           </div>
//         )}
//       </AnimatePresence>
//     </>
//   );
// }











// import React, { useState } from 'react';
// import { motion, AnimatePresence } from 'framer-motion';
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import '../design/LoginModal.css';
// import { getApiUrl } from '../../utils/api';

// // --- INLINE SVG ICONS ---
// const UserIcon = () => (
//   <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
//     <circle cx="12" cy="7" r="4"></circle>
//   </svg>
// );

// const LockIcon = () => (
//   <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
//     <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
//   </svg>
// );

// const GoogleIcon = () => (
//   <svg viewBox="0 0 48 48" width="24px" height="24px">
//     <path fill="#FFC107" d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"></path>
//     <path fill="#FF3D00" d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"></path>
//     <path fill="#4CAF50" d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.222,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"></path>
//     <path fill="#1976D2" d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.574l6.19,5.238C39.99,34.556,44,29.865,44,24C44,22.659,43.862,21.35,43.611,20.083z"></path>
//   </svg>
// );

// export default function LoginModal({ isOpen, onClose, openRegister }) {
//   const [username, setUsername] = useState('');
//   const [password, setPassword] = useState('');
//   const [showPassword, setShowPassword] = useState(false);

//   // ✅ Validation
//   const validateLogin = (credentials) => {
//     const errors = {};
//     if (!credentials.username) errors.username = "Username is required.";
//     if (!credentials.password) errors.password = "Password is required.";
//     return errors;
//   };

//   // ✅ Submit handler to call PHP API
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const errors = validateLogin({ username, password });
//     if (Object.keys(errors).length > 0) {
//       Object.values(errors).forEach(err => toast.error(err));
//       return;
//     }

//     toast.info("🔄 Logging in...");

//     try {
//       const response = await fetch(getApiUrl("validate-login.php"), {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           user_name: username,  // must match PHP key
//           password: password
//         }),
//       });

//       const data = await response.json();

//       if (data.success) {
//         toast.success("✅ " + data.message);
//         localStorage.setItem("userSession", JSON.stringify(data.user));

//         // Optional: redirect based on user type
//         if (data.user.user_type === "brand") {
//           window.location.href = "/brand-dashboard";
//         } else if (data.user.user_type === "investor") {
//           window.location.href = "/investor-dashboard";

//         }

//         onClose();
//       } else {
//         toast.error("❌ " + data.message);
//       }
//     } catch (error) {
//       console.error("Login Error:", error);
//       toast.error("⚠ Unable to connect to server.");
//     }
//   };

//   // Framer Motion Variants
//   const backdropVariants = { hidden: { opacity: 0 }, visible: { opacity: 1 } };
//   const modalVariants = {
//     hidden: { opacity: 0, scale: 0.9, y: -50 },
//     visible: {
//       opacity: 1,
//       scale: 1,
//       y: 0,
//       transition: { type: 'spring', stiffness: 260, damping: 25, staggerChildren: 0.05 },
//     },
//     exit: { opacity: 0, scale: 0.9, y: 50, transition: { duration: 0.2 } },
//   };
//   const itemVariants = { hidden: { opacity: 0, y: 20 }, visible: { opacity: 1, y: 0 } };

//   return (
//     <>
//       <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
//       <AnimatePresence>
//         {isOpen && (
//           <div className="login-modal-overlay">
//             <motion.div
//               className="login-modal-backdrop"
//               variants={backdropVariants}
//               initial="hidden"
//               animate="visible"
//               exit="hidden"
//               onClick={onClose}
//             />
//             <motion.div
//               className="login-modal-box"
//               variants={modalVariants}
//               initial="hidden"
//               animate="visible"
//               exit="exit"
//             >
//               {/* --- Login Form --- */}
//               <motion.div className="login-form-content" variants={itemVariants}>
//                 <button className="close-modal-btn" onClick={onClose}>✖</button>
//                 <h2 className="login-title">Login to Your Account</h2>
//                 <form onSubmit={handleSubmit}>
//                   <motion.div className="input-group" variants={itemVariants}>
//                     <span className="icon"><UserIcon /></span>
//                     <input
//                       type="text"
//                       placeholder="Username"
//                       value={username}
//                       onChange={(e) => setUsername(e.target.value)}
//                     />
//                   </motion.div>
//                   <motion.div className="input-group password-group" variants={itemVariants}>
//                     <span className="icon"><LockIcon /></span>
//                     <input
//                       type={showPassword ? 'text' : 'password'}
//                       placeholder="Password"
//                       value={password}
//                       onChange={(e) => setPassword(e.target.value)}
//                     />
//                     <span
//                       className="toggle-password"
//                       onClick={() => setShowPassword(!showPassword)}
//                       title={showPassword ? 'Hide Password' : 'Show Password'}
//                     >
//                       {showPassword ? '🙈' : '👁'}
//                     </span>
//                   </motion.div>
//                   <motion.div className="submit-row" variants={itemVariants}>
//                     <button type="submit" className="submit-btn">SIGN IN</button>
//                     <a href="#" className="forgot-link">Forgot Password?</a>
//                   </motion.div>
//                 </form>

//                 <motion.div className="social-login" variants={itemVariants}>
//                   <p className="or-text">or Sign in With</p>
//                   <button className="google-btn"><GoogleIcon /></button>
//                   <p className="login-text">
//                     New User?{' '}
//                     <a
//                       href="#"
//                       onClick={(e) => { e.preventDefault(); onClose(); openRegister(); }}
//                     >
//                       Click here to Register
//                     </a>
//                   </p>
//                 </motion.div>
//               </motion.div>

//               {/* --- Why Register Section --- */}
//               <motion.div className="why-login" variants={itemVariants}>
//                 <div>
//                   <h4>Welcome Back!</h4>
//                   <p>Access your personalized dashboard and manage your <strong>franchise opportunities</strong> seamlessly.</p>
//                   <p>Stay connected with a network of <strong>investors, experts, and entrepreneurs</strong> to grow your business.</p>
//                   <p>Track your applications, get expert guidance, and <strong>expand your business</strong> efficiently with FranmaxIndia.</p>
//                 </div>
//               </motion.div>
//             </motion.div>
//           </div>
//         )}
//       </AnimatePresence>
//     </>
//   );
// }












import React, { useState } from 'react';

import { motion, AnimatePresence } from 'framer-motion';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../design/LoginModal.css';
import { getApiUrl } from '../../utils/api';
import { useNavigate } from "react-router-dom";

// --- INLINE SVG ICONS ---
const UserIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
    <circle cx="12" cy="7" r="4"></circle>
  </svg>
);

const LockIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
    <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
  </svg>
);

const GoogleIcon = () => (
  <svg viewBox="0 0 48 48" width="24px" height="24px">
    <path fill="#FFC107" d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"></path>
    <path fill="#FF3D00" d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"></path>
    <path fill="#4CAF50" d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.222,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"></path>
    <path fill="#1976D2" d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.574l6.19,5.238C39.99,34.556,44,29.865,44,24C44,22.659,43.862,21.35,43.611,20.083z"></path>
  </svg>
);

export default function LoginModal({ isOpen, onClose, openRegister }) {
  const navigate = useNavigate(); // ✅ must be inside the component
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  // ✅ Validation
  const validateLogin = (credentials) => {
    const errors = {};
    if (!credentials.username) errors.username = "Username is required.";
    if (!credentials.password) errors.password = "Password is required.";
    return errors;
  };

  // ✅ Submit handler to call PHP API
  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   const errors = validateLogin({ username, password });
  //   if (Object.keys(errors).length > 0) {
  //     Object.values(errors).forEach(err => toast.error(err));
  //     return;
  //   }

  //   toast.info("🔄 Logging in...");

  //   try {
  //     const response = await fetch(getApiUrl("validate-login.php"), {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify({
  //         user_name: username,  // must match PHP key
  //         password: password
  //       }),
  //     });

  //     const data = await response.json();

  //     if (data.success) {
  //      toast.info("Logging in...");
  //    setTimeout(() => {
  //      if (username === "investor" && password === "password") {
  //        toast.success("✅ Login successful! Welcome, Investor.");
  //        localStorage.setItem('investor_session', JSON.stringify({ name: 'Investor User', user_type: 'investor'}));
  //      } else if (username === "brand" && password === "password") {
  //        toast.success("✅ Login successful! Welcome, Brand.");
  //        localStorage.setItem('userSession', JSON.stringify({ name: 'Brand User', user_type: 'brand'}));
  //      } else {
  //        toast.error("❌ Invalid credentials.");
  //      }
  //    }, 1500);

  //       // Optional: redirect based on user type
  //       if (data.user.user_type === "brand") {
  //         window.location.href = "/brand-dashboard";
  //       } else if (data.user.user_type === "investor") {
  //         window.location.href = "/investor-dashboard";
  //       }

  //       onClose();
  //     } else {
  //       toast.error("❌ " + data.message);
  //     }
  //   } catch (error) {
  //     console.error("Login Error:", error);
  //     toast.error("⚠️ Unable to connect to server.");
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const errors = validateLogin({ username, password });
    if (Object.keys(errors).length > 0) {
      Object.values(errors).forEach(err => toast.error(err));
      return;
    }

    toast.info("🔄 Validating credentials...");

    try {
      const response = await fetch(getApiUrl("validate-login.php"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          user_name: username,
          password: password,
        }),
      });

      const data = await response.json();
      console.log(data);

      if (data.success) {
        toast.success("✅ Login successful!");

        // Store session dynamically based on user_type
        if (data.user.user_type === "investor") {
          localStorage.setItem(
            "investor_session",
            JSON.stringify({
               id: data.user.id,
              name: data.user.name,
              user_type: data.user.user_type,
              username: data.user.username,
              email: data.user.email,
            })
          );
          window.location.href = "/investor-dashboard";
        }
        else if (data.user.user_type?.toLowerCase() === "brand") {
          console.log("Redirecting to brand dashboard...");
          localStorage.setItem("userSession", JSON.stringify({
            id: data.user.id,
            name: data.user.name,
            user_type: data.user.user_type,
            username: data.user.username,
            email: data.user.email,
          }));
          console.log("Session stored:", localStorage.getItem("userSession"));
           window.location.href = "/brand/dashboard";
        }
        else {
          toast.error("⚠️ Unknown user type.");
        }
      } else {
        toast.error(`❌ ${data.message}`);
      }
    } catch (error) {
      console.error("Login error:", error);
      toast.error("⚠️ Server error. Please try again later.");
    }
  };




  // Framer Motion Variants
  const backdropVariants = { hidden: { opacity: 0 }, visible: { opacity: 1 } };
  const modalVariants = {
    hidden: { opacity: 0, scale: 0.9, y: -50 },
    visible: {
      opacity: 1,
      scale: 1,
      y: 0,
      transition: { type: 'spring', stiffness: 260, damping: 25, staggerChildren: 0.05 },
    },
    exit: { opacity: 0, scale: 0.9, y: 50, transition: { duration: 0.2 } },
  };
  const itemVariants = { hidden: { opacity: 0, y: 20 }, visible: { opacity: 1, y: 0 } };

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
      <AnimatePresence>
        {isOpen && (
          <div className="login-modal-overlay">
            <motion.div
              className="login-modal-backdrop"
              variants={backdropVariants}
              initial="hidden"
              animate="visible"
              exit="hidden"
              onClick={onClose}
            />
            <motion.div
              className="login-modal-box"
              variants={modalVariants}
              initial="hidden"
              animate="visible"
              exit="exit"
            >
              {/* --- Login Form --- */}
              <motion.div className="login-form-content" variants={itemVariants}>
                <button className="close-modal-btn" onClick={onClose}>✖</button>
                <h2 className="login-title">Login to Your Account</h2>
                <form onSubmit={handleSubmit}>
                  <motion.div className="input-group" variants={itemVariants}>
                    <span className="icon"><UserIcon /></span>
                    <input
                      type="text"
                      placeholder="Username"
                      value={username}
                      onChange={(e) => setUsername(e.target.value)}
                    />
                  </motion.div>
                  <motion.div className="input-group password-group" variants={itemVariants}>
                    <span className="icon"><LockIcon /></span>
                    <input
                      type={showPassword ? 'text' : 'password'}
                      placeholder="Password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    <span
                      className="toggle-password"
                      onClick={() => setShowPassword(!showPassword)}
                      title={showPassword ? 'Hide Password' : 'Show Password'}
                    >
                      {showPassword ? '🙈' : '👁️'}
                    </span>
                  </motion.div>
                  <motion.div className="submit-row" variants={itemVariants}>
                    <button type="submit" className="submit-btn">SIGN IN</button>
                    <a href="#" className="forgot-link">Forgot Password?</a>
                  </motion.div>
                </form>

                <motion.div className="social-login" variants={itemVariants}>
                  <p className="or-text">or Sign in With</p>
                  <button className="google-btn"><GoogleIcon /></button>
                  <p className="register-text">
                    New User?{' '}
                    <a
                      href="#"
                      onClick={(e) => { e.preventDefault(); onClose(); openRegister(); }}
                    >
                      Click here to Register
                    </a>
                  </p>
                </motion.div>
              </motion.div>

              {/* --- Why Register Section --- */}
              <motion.div className="why-register" variants={itemVariants}>
                <div>
                  <h4>Welcome Back!</h4>
                  <p>Access your personalized dashboard and manage your <strong>franchise opportunities</strong> seamlessly.</p>
                  <p>Stay connected with a network of <strong>investors, experts, and entrepreneurs</strong> to grow your business.</p>
                  <p>Track your applications, get expert guidance, and <strong>expand your business</strong> efficiently with FranmaxIndia.</p>
                </div>
              </motion.div>
            </motion.div>
          </div>
        )}
      </AnimatePresence>
    </>
  );
}
